<template>
  <div class="container">
    <div class="title">{{ detail.title }}</div>
    <div v-html="detail.content"></div>
  </div>
</template>

<script>
export default {
  name: "PrivacyAgreement",
  props: {
    query: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      baseUrl: "http://47.99.46.61:8585",
      detail: {
        title: "",
        content: "",
      },
    };
  },
  created() {
    this.getAgreement();
  },
  methods: {
    async getAgreement() {
      let response = await fetch(
        `${this.baseUrl}/app/agreement/detail?port=${this.query.port}&type=${
          this.query.type
        }`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const { data } = await response.json();
      this.detail = data;
    },
  },
  mounted() {},
  watch: {},
  computed: {},
  filters: {},
};
</script>

<style scoped>
.container {
  padding: 1.5rem 1.5rem 5rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.8rem;
}
</style>
